package analytics

interface Analytics {
    fun screen(name: String, properties: Map<String, Any?> = emptyMap())
    fun track(event: AnalyticsEvent)
    fun identify(userId: String, properties: Map<String, Any?> = emptyMap())
    fun setPersonProperties(properties: Map<String, Any?>)
    fun register(key: String, value: Any?)
    fun unregister(key: String)
    fun optOut(optedOut: Boolean)
    fun reset()
    fun flush()
}
